let rootUrl: string | null = null

export function proxyResponse(promise: Promise<Response>) {
  return promise.then((response) => {
    if (!response.ok) {
      if (response.status === 500) {
        return response.json().then((data) => {
          return data
        })
      }

      throw {
        status: response.status,
        data: {},
      }
    }

    return response.json()
  })
}

export function createRootUrl() {
  const l = location

  if (l.hostname === 'localhost' && l.port === '9000') {
    const apiUrl =
      //  l.hash === '#debug' ? 'https://localhost:7071' : 'https://h25api.for2home.com'
      l.hash === '#debug' ? 'https://localhost:7071' : 'https://cocinas-tpcinternalapi.for2home.com'
    // l.hash === '#debug' ? 'https://localhost:7071' : 'https://planificador3dapi.cocinas-tpc.com'

    // l.hash === '#debug' ? 'https://localhost:7071' : 'https://cocinas-tpc43api.for2home.com'

    // Url Muebles Atemporal
    // l.hash === '#debug' ? 'https://localhost:7071' : 'https://pf032api.for2home.com'

    // const apiUrl =
    // l.hash === '#debug' ? 'https://localhost:7071' : 'https://for2inspirationapi.for2home.com'
    return apiUrl
  }

  if (l.hostname === 'for2inspirationadmin.for2home.com') {
    return 'https://for2inspirationapi.for2home.com'
  }

  if (l.hostname === 'for2inspiration.for2home.com') {
    return 'https://for2inspirationapi.for2home.com'
  }

  const split = l.hostname.split('.')
  split[0] = split[0] + 'api'

  let url = l.protocol + '//' + split.join('.')

  if (l.port !== '') url += ':' + l.port
  return url
}

export function getProxyUrl(endpoint: string) {
  // SIEMPRE recalcular rootUrl para detectar cambios en la API (incluso si cambias el código y recargas)
  const currentRootUrl = createRootUrl()

  if (rootUrl === null || rootUrl !== currentRootUrl) {
    const urlChanged = rootUrl !== null && rootUrl !== currentRootUrl

    if (urlChanged) {
      const glbCache = (window as any).glbCache
      if (glbCache && glbCache.clear) {
        glbCache.clear()
      }

      window.dispatchEvent(
        new CustomEvent('apiUrlChanged', { detail: { oldUrl: rootUrl, newUrl: currentRootUrl } }),
      )
    }

    rootUrl = currentRootUrl
  }

  // Si endpoint es vacío, devolver solo la URL base sin barra final
  if (!endpoint) {
    return rootUrl
  }

  return `${rootUrl}/${endpoint}`
}

export function getUserToken(): string {
  const token = sessionStorage.getItem('userToken')
  return `buda ${token || ''}`
}

type Header = {
  method?: 'get' | 'post'
  body?: Record<string, unknown> | string | undefined
  headers?: Record<string, unknown>
}

export function getBaseHeaders({
  method = 'get',
  body = undefined,
  headers = {},
}: Header = {}): RequestInit {
  const toSend: RequestInit = {
    method,
    body: body && typeof body !== 'string' ? JSON.stringify(body) : body,
    headers: {
      Authorization: getUserToken(),
      mode: 'cors',
      'Accept-Language': navigator.language ?? 'en',
      ...headers,
    },
  }

  if (!body) {
    delete toSend.body
  }

  return toSend
}
